import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { DOMParser as ProseMirrorDOMParser } from "@tiptap/pm/model";
import { closeSliceEdgesAroundLists, selectionWithinList } from "../../lib/tipTapExtensions/pasteFromTextBox";
import { hasRichFormatting, plainTextToHtml } from "../../../../src/shared/markdownPasteUtils";

export const selectClipboardHtml = (html: string, text: string): string | null => {
  if (hasRichFormatting(html) || /<(ul|ol|li)(?=[\s/>])/i.test(html)) return html;
  return text ? plainTextToHtml(text) : null;
};

const pasteHandlerKey = new PluginKey("pasteHandlerPlugin");

/** Preserve supported HTML formatting and lists; convert plain text once. */
export const PasteHandler = Extension.create({
  name: "pasteHandler",
  priority: 1000, // High priority to run before other handlers
  addProseMirrorPlugins() {
    const editor = this.editor;
    return [
      new Plugin({
        key: pasteHandlerKey,
        props: {
          handlePaste: (view, event) => {
            if (!editor) return false;

            const { clipboardData } = event;
            if (!clipboardData) return false;

            event.preventDefault();
            event.stopPropagation();

            const html = clipboardData.getData("text/html");
            const text = clipboardData.getData("text/plain");

            const htmlToInsert = selectClipboardHtml(html, text);

            if (!htmlToInsert) return true;

            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = htmlToInsert;
            tempDiv.querySelectorAll("script, style").forEach((el) => el.remove());

            const parser = ProseMirrorDOMParser.fromSchema(view.state.schema);
            let slice = parser.parseSlice(tempDiv);
            // Keep edge list items from merging into the surrounding paragraph.
            // Inside a list, retain the usual open-slice item merging behavior.
            if (!selectionWithinList(view.state)) {
              slice = closeSliceEdgesAroundLists(slice, view.state.schema);
            }

            if (slice.content.size > 0) {
              const tr = view.state.tr.replaceSelection(slice);
              view.dispatch(tr);
            }

            return true;
          },
        },
      }),
    ];
  },
});
